import React from "react";
import { FaFacebookF, FaLinkedinIn, FaXTwitter } from "react-icons/fa6";

// Modern, single-band footer. Uses brand-accurate icons (FaXTwitter is the
// current X logo; FaFacebookF and FaLinkedinIn are the filled monogram
// marks brand teams ship in their brand kits). Layout collapses cleanly to
// a stacked column on mobile and lays out as a 3-section row on md+.
const NAV_LINKS = [
  { label: "Privacy Policy", href: "/privacy" },
  { label: "Terms of Service", href: "/terms" },
  { label: "Child Safety Standards", href: "/child-safety-standards" },
  { label: "Data Deletion", href: "/deletedata.html" },
  { label: "Support", href: "/community-group" },
];

const SOCIAL_LINKS = [
  {
    label: "Eqlize Now on Facebook",
    href: "https://www.facebook.com/eqlizenow",
    Icon: FaFacebookF,
  },
  {
    label: "Eqlize Now on LinkedIn",
    href: "https://www.linkedin.com/company/eqlizenow",
    Icon: FaLinkedinIn,
  },
  {
    label: "Eqlize Now on X",
    href: "https://x.com/EqlizeNow",
    Icon: FaXTwitter,
  },
];

const SocialLink = ({ href, label, Icon }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    aria-label={label}
    className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-secondary/15 bg-secondary/5 text-secondary transition-colors duration-150 hover:border-secondary/40 hover:bg-secondary/10 focus:outline-none focus:ring-2 focus:ring-secondary/30"
  >
    <Icon className="h-[15px] w-[15px]" aria-hidden="true" />
  </a>
);

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-auto w-full bg-primary text-secondary">
      <div className="mx-auto w-full max-w-[1400px] px-6 sm:px-8 py-10 md:py-12">
        <div className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between">
          <div className="max-w-md">
            <p className="text-[20px] md:text-[22px] font-semibold tracking-tight">
              Eqlize Now
            </p>
            <p className="mt-2 text-[13px] md:text-[14px] leading-relaxed text-secondary/65">
              Run a campaign, grow a community, and share what you raise — all in one place.
            </p>
          </div>

          <nav aria-label="Footer">
            <ul className="flex flex-wrap gap-x-6 gap-y-2 text-[14px] text-secondary/80">
              {NAV_LINKS.map(({ label, href }) => (
                <li key={href}>
                  <a
                    href={href}
                    className="underline underline-offset-2 decoration-secondary/40 transition-colors duration-150 hover:text-secondary hover:decoration-secondary"
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div className="flex items-center gap-3">
            {SOCIAL_LINKS.map((s) => (
              <SocialLink key={s.href} {...s} />
            ))}
          </div>
        </div>

        <div className="mt-10 border-t border-secondary/10 pt-6 flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
          <p className="text-[12px] md:text-[13px] text-secondary/55">
            © {year} Eqlize Now. All rights reserved.
          </p>
          <p className="text-[12px] md:text-[13px] text-secondary/55">
            Powered by{" "}
            <a
              href="https://www.skipfour.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-secondary/80 underline underline-offset-2 decoration-secondary/40 hover:text-secondary hover:decoration-secondary transition-colors duration-150"
            >
              Skipfour
            </a>
            , Carmel, IN
            .
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
